var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.292 15c.666 0 1.213.507 1.283 1.157l.008.142v.01h.007c0 5.79 4.04 10.625 9.436 11.812a11.98 11.98 0 0 0 2.043.266l.525.012h.06c.714 0 1.29.58 1.29 1.3 0 .669-.502 1.22-1.15 1.29l-.14.009h.156a14.634 14.634 0 0 1-3.505-.376c-6.358-1.474-11.128-7.13-11.3-13.934L1 16.319v-.02c0-.717.579-1.3 1.292-1.3zm13.307 15.997h.027-.028zM15.949 7c4.953 0 8.97 4.03 8.97 9s-4.017 9-8.97 9C10.994 25 6.98 20.97 6.98 16c0-4.97 4.015-9 8.97-9zm0 3.803A5.184 5.184 0 0 0 10.771 16a5.19 5.19 0 0 0 5.177 5.195A5.184 5.184 0 0 0 21.127 16a5.19 5.19 0 0 0-3.195-4.798 5.182 5.182 0 0 0-1.984-.397v-.002zm12.956 7.53c.734 0 1.33.598 1.33 1.333a1.332 1.332 0 0 1-1.84 1.232 1.33 1.33 0 0 1-.818-1.232c0-.735.595-1.333 1.328-1.333zM16.273 1h.028c7.943 0 14.402 6.378 14.594 14.32l.006.36v.02c0 .718-.579 1.3-1.292 1.3a1.296 1.296 0 0 1-1.284-1.158l-.007-.142v-.02c-.003-6.561-5.202-11.9-11.683-12.076l-.33-.005h-.06a1.294 1.294 0 0 1-1.291-1.3c0-.719.578-1.3 1.291-1.3h.029zM2.993 11c.734 0 1.33.596 1.33 1.333a1.332 1.332 0 0 1-1.84 1.231 1.33 1.33 0 0 1-.818-1.232A1.33 1.33 0 0 1 2.993 11z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrc);
export default __webpack_public_path__ + "static/media/ORC.b5dedf1883cd4775ae9ed72f883977a9.svg";
export { ForwardRef as ReactComponent };